/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Scope_GlobalInputs */

const en_enum_setting_scope_global = /** @type {(inputs: Enum_Setting_Scope_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope Global`)
};

const de_enum_setting_scope_global = /** @type {(inputs: Enum_Setting_Scope_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global`)
};

/**
* | output |
* | --- |
* | "Scope Global" |
*
* @param {Enum_Setting_Scope_GlobalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_scope_global = /** @type {((inputs?: Enum_Setting_Scope_GlobalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Scope_GlobalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_scope_global(inputs)
	return de_enum_setting_scope_global(inputs)
});